<template>
  <v-card class="left-vertical-card">
    <div class="d-flex bg-titre">
      <div class="align-self-center pl-3 mr-auto">
        <div class="d-flex flex-column">
          <div class="titre-h3 secondary--text ">
            Itinéraire technique
          </div>
          <div class="titre-h5 secondary--text ">
            Engrais <span class="secondary--text align-self-center ">({{ engrais[0].typeCulture.nom }})</span>
          </div>
        </div>
      </div>

      <v-btn
        class="align-self-center"
        text
        @click="onClose"
      >
        <v-icon color="secondary">
          mdi-close
        </v-icon>
      </v-btn>
    </div>
    <div class="d-flex flex-column mt-3 mx-4">
      <v-card
        v-for="uneEngrais in engrais"
        :key="uneEngrais.id"
        class="pa-2 mb-2 background"
      >
        <div class="d-flex justify-space-between">
          <div class="secondary--text titre-h5">
            {{ uneEngrais.typeRubrique.libelleSousRubrique }}
            <v-chip
              v-if="uneEngrais.typeRubrique.statut === 'OBLIGATOIRE'"
              small
              
              color="secondary"
            >
              <span class="text-lowercase">
                {{ uneEngrais.typeRubrique.statut | capitalize }}
              </span>
            </v-chip>
          </div>
          <div class="d-flex justify-space-around">
            <AgrButton
              icon
              @click="onOpenUpdateParametreModal(uneEngrais)"
            >
              <v-icon color="grey darken-2">
                mdi-pencil-outline
              </v-icon>
            </AgrButton>
            <AgrButton
              v-if="uneEngrais.typeRubrique.statut === 'SUPPRIMABLE'"
              icon
              @click="onOpenDeleteParametreModal(uneEngrais)"
            >
              <v-icon color="grey darken-2">
                mdi-delete-outline
              </v-icon>
            </AgrButton>
          </div>
        </div>

        <div
          v-if="!uneEngrais.typeRubrique.isValeurEconomiqueUniquement"
          class="d-flex justify-space-between"
        >
          <div class="texte py-0 texte-gris-fonce font-weight-light">
            Valeur min
          </div>
          <div class="align-self-center texte py-0 secondary--text font-weight-light">
            {{ uneEngrais.valeurMin != null ? uneEngrais.valeurMin : '-' }} 
            <span v-if="uneEngrais.typeRubrique.libelleSousRubrique === 'CaO'"> kg/ha</span>
            <span v-else>u</span>
          </div>
        </div>
        <div
          v-if="!uneEngrais.typeRubrique.isValeurEconomiqueUniquement"
          class="d-flex justify-space-between"
        >
          <div class="texte py-0 texte-gris-fonce">
            Valeur défaut
          </div>
          <div class="align-self-center texte py-0 secondary--text">
            {{ uneEngrais.valeurDefaut != null ? uneEngrais.valeurDefaut : '-' }}
            <span v-if="uneEngrais.typeRubrique.libelleSousRubrique === 'CaO'"> kg/ha</span>
            <span v-else>u</span>
          </div>
        </div>
        <div
          v-if="!uneEngrais.typeRubrique.isValeurEconomiqueUniquement"
          class="d-flex justify-space-between"
        >
          <div class="texte py-0 texte-gris-fonce font-weight-light">
            Valeur max
          </div>
          <div class="align-self-center texte py-0 secondary--text font-weight-light">
            {{ uneEngrais.valeurMax != null ? uneEngrais.valeurMax : '-' }}
            <span v-if="uneEngrais.typeRubrique.libelleSousRubrique === 'CaO'"> kg/ha</span>
            <span v-else>u</span>
          </div>
        </div>
        <div
          v-if="uneEngrais.typeRubrique.isValeurEconomiqueObligatoire || uneEngrais.typeRubrique.isValeurEconomiqueUniquement"
          class="d-flex justify-space-between"
        >
          <div class="texte py-0 texte-gris-fonce">
            Coût
          </div>
          <div class="align-self-center texte py-0 secondary--text">
            {{ uneEngrais.valeurEconomique != null ? uneEngrais.valeurEconomique : '-' }} €/ha
          </div>
        </div>
        <v-dialog
          v-if="isUpdateParametreModalOpen"
          v-model="isUpdateParametreModalOpen"
          width="500"
        >
          <UpdateParametreModal
            :parametre="parametre"
            :type-culture="engrais[0].typeCulture"
            :type-rubrique="engrais[0].typeRubrique"
            :unite="parametre && parametre.typeRubrique.libelleSousRubrique === 'CaO' ? 'kg/ha' : 'unités/ha'"
            is-rubrique-engrais
            @close="closeModalNouveauParametre()"
            @updatedParametre="updatedParametre"
          />
        </v-dialog>
      </v-card>
      <div class="d-flex justify-space-between my-4">
        <AgrButton
          outlined
          @click="onOpenNouveauParametreModal()"
        >
          Ajouter un engrais
        </AgrButton>
        <AgrButton
          outlined
          @click="onClose()"
        >
          Fermer
        </AgrButton>
      </div>
    </div>

    <v-dialog
      v-model="isConfirmDeleteParametreModalOpen"
      persistent
      width="500"
    >
      <ConfirmModal
        title="Confirmation"
        cancel-text="Non"
        confirm-text="Oui"
        @cancel="isConfirmDeleteParametreModalOpen=false"
        @confirm="confirmDeleteParametre()"
      >
        Souhaitez-vous vraiment supprimer ce paramètre ?
      </ConfirmModal>
    </v-dialog>
  </v-card>
</template>

<script>
import { AgrButton } from '@agrial/ui'
import ConfirmModal from '@/components/modal/confirm-modal.vue'
import UpdateParametreModal from './update-parametre-modal.vue'
import { mapActions } from 'vuex'

export default {
  name: 'UpdateEngraisModal',
  components: {AgrButton, ConfirmModal, UpdateParametreModal},
  props: {
    engrais: {
      type: Array,
      default: null
    }
  },

  data () {
    return {
      loading: false,
      erreur: null,
      isUpdateParametreModalOpen: false,
      isConfirmDeleteParametreModalOpen: false,
      parametre: null,
      rules: {
        required: value => (value !== null && value !== '') || 'Champ requis',
      }
    }
  },

  methods: {
    ...mapActions({
      deleteAdminComparateurParametreMarge: 'comparateurMarge/deleteAdminComparateurParametreMarge'
    }),
    onClose () {
      this.$emit('close')
    },
    onOpenNouveauParametreModal () {
      this.isUpdateParametreModalOpen = true
      this.parametre = null
    },
    closeModalNouveauParametre () {
      this.parametre = null
      this.isUpdateParametreModalOpen = false
    },
    onOpenUpdateParametreModal (value) {
      this.parametre = value
      this.isUpdateParametreModalOpen = true
    },
    onOpenDeleteParametreModal (value) {
      this.parametre = value
      this.isConfirmDeleteParametreModalOpen = true
    },
    confirmDeleteParametre () {
      this.deleteAdminComparateurParametreMarge(this.parametre)
      .then(() => this.$emit('updatedParametre', this.engrais[0].typeCulture.id))
      this.isConfirmDeleteParametreModalOpen = false
      this.parametre = null
    },
    updatedParametre () {
      this.$emit('updatedParametre', this.engrais[0].typeCulture.id)
      this.isUpdateParametreModalOpen = false
    }
  }
}
</script>
<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0 !important;
}

.background {
  background: #EFF0E1;
}

.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}

.input-number {
  width: 100%;
}
</style>
